/**
 * First we will load all of this project's JavaScript dependencies which
 * includes Vue and other libraries. It is a great starting point when
 * building robust, powerful web applications using Vue and Laravel.
 */

require("./bootstrap");
require("../../node_modules/slick-carousel/slick/slick.js");
require("axios");

$(document).ready(() => {
  /* for hamburger change */
  var forEach = function(t, o, r) {
    if ("[object Object]" === Object.prototype.toString.call(t))
      for (var c in t)
        Object.prototype.hasOwnProperty.call(t, c) && o.call(r, t[c], c, t);
    else for (var e = 0, l = t.length; l > e; e++) o.call(r, t[e], e, t);
  };
  var hamburgers = document.querySelectorAll(".hamburger");
  if (hamburgers.length > 0) {
    forEach(hamburgers, function(hamburger) {
      hamburger.addEventListener(
        "click",
        function(e) {
          e.preventDefault();
          this.classList.toggle("is-active");
        },
        false
      );
    });
  }

  $("[btn-submit]").on("click", e => {
    console.log("Generating PDF");
    $(e.target).text("Generando...");
    $(e.target).prop("disabled", true);
    window.location.href = e.target.getAttribute("btn-submit-href");
    setTimeout(() => {
      $(e.target).text("Imprimir en PDF");
      $(e.target).prop("disabled", false);
    }, 3500);
  });

  $(document).on("change", ".imageInput", evt => {
    let outImage = evt.target.getAttribute("showImageTarget");
    let outText = evt.target.getAttribute("showTextTarget");

    let tgt = evt.target || window.event.srcElement,
      files = tgt.files;

    // FileReader support
    let number = 0;
    if (FileReader && files && files.length) {
      let fr = new FileReader();
      fr.onload = function() {
        number++;
        document.getElementById(outImage).src = fr.result;
        document.getElementById(outText).innerHTML =
          number === 1
            ? `Ha seleccionado ${number} imagen`
            : `Ha seleccionado ${number} imágenes`;
      };
      fr.readAsDataURL(files[0]);
    }
  });

  /* remove image from front */
  $(document).on("click", ".btn-remove-image", e => {
    let remove = e.target.getAttribute("remove");
    let input = document.getElementById(`photo${remove}`);
    let outImage = input.getAttribute("showImageTarget");
    let outText = input.getAttribute("showTextTarget");
    document.getElementById(outImage).src = "";
    document.getElementById(outText).innerHTML = "Seleccionar Archivo";
    input.value = "";

    if (e.target.hasAttribute("edit")) {
      console.log("has edit");
      axios.defaults.headers.common = {
        "X-Requested-With": "XMLHttpRequest",
        "X-CSRF-TOKEN": document
          .querySelector('meta[name="csrf-token"]')
          .getAttribute("content")
      };

      if (e.target.hasAttribute("oficinas")) {
        console.log("has oficinas");
        axios
          .post("/auth/borrar-imagen-oficina", {
            id: document.getElementById("id").value,
            imagen: remove
          })
          .then(() => console.log("Imagen oficina borrada"))
          .catch(err => console.error(err));
      } else {
        console.log("viviendas");
        axios
          .post("/auth/borrar-imagen-vivienda", {
            id: document.getElementById("id").value,
            imagen: remove
          })
          .then(() => console.log("Imagen vivienda borrada"))
          .catch(err => console.error(err));
      }
    }
  });
});
